import { computed, unref, type MaybeRef } from 'vue'
import type { Alert } from '../model/alert'

export function useAlertCreationDate(alert: MaybeRef<Alert>) {
  const alertCreationDate = computed(() => {
    const alertVal = unref(alert)

    if (alertVal.type === 'message' || alertVal.type === 'ping') {
      return alertVal.message.createdAt
    }

    if (alertVal.type === 'reply') {
      return alertVal.reply.createdAt
    }

    if (alertVal.type === 'reaction') {
      return alertVal.reaction?.createdAt ?? null
    }

    return null
  })

  return alertCreationDate
}
